<template>
  <div class="users-pg">
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="form-npa">
        <div class="position">
          <div class="bg-white p-20">
            <div class="form-head">
              <Widget position="menu_profile"/>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile"/>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <div class="search-head">
                <AppealSearch
                  v-bind:search="search"
                  :user="user"
                  :developers="refDeveloper"
                  :appealTypes="refAppealType"
                  :appealStatuses="refAppealStatus"
                  :applicantTypes="refApplicantType"
                  @search-appeal="getDataSearch($event)"
                  @reset-appeal="resetDataSearch($event)"
                />
              </div>
              <div class="search-result">
                <div class="table-overflow" v-if="appeals.length">
                  <table>
                    <thead>
                    <tr>
                      <td>
                        <a @click="sortData('date')">
                          <i class="pro-icon-arrow-bottom1"></i>
                          {{ $t('№, дата') }}
                        </a>
                      </td>
                      <td>
                        <a @click="sortData('fio')">
                          <i class="pro-icon-arrow-bottom1"></i>
                          {{ $t('ФИО') }}
                        </a>
                      </td>
                      <td>
                          {{ $t('Сведения о заявителе') }}
                      </td>
                      <td>
                          {{ $t('Обращение') }}
                      </td>
                      <td>
                        {{ $t('Тип, статус') }}
                      </td>
                      <td>
                        {{ $t('Ответ дал') }}
                      </td>
                      <td v-if="user && (user.roleCoordinator === true || user.roleAdmin === true)">
                        <a @click="sortData('whom')">
                          <i class="pro-icon-arrow-bottom1"></i>
                          {{ $t('Кому') }}
                        </a>
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="appeal in appeals" :key="appeal.id" v-bind:class="{ 'unread': appeal.appeal_view }">
                      <td>
                        {{ new Date(appeal.date_and_creation_date) | dateFormat('DD.MM.YYYY')}}
                      </td>
                      <td>{{ appeal.second_name }} {{ appeal.first_name }} {{ appeal.last_name }}</td>
                      <td>
                        <span> {{ appeal.applicant_type.transName }} <br/> </span>
                        <span> {{ appeal.email }} <br/> </span>
                        <span> {{ appeal.ip }} <br/> </span>
                        <span v-if="appeal.phone"> {{ appeal.phone }} <br/> </span>
                        <span v-if="appeal.name"> {{ appeal.name }} <br/> </span>
                      </td>
                      <td>
                        <router-link
                          :to="$i18nRoute({ name: 'appeal', params: { id: appeal.id } })">
                          {{ appeal.text | splitTextIntoLines(2, 18)}}
                        </router-link>
                      </td>
                      <td>
                        {{ appeal.appeal_type.transName }},
                        <History
                          :histories="appeal.histories"
                          :statusName="appeal.appeal_status.transName"
                        />
                      </td>
                      <td>
                        <span v-if="appeal.reply_user">
                          {{ appeal.reply_user.second_name }} {{ appeal.reply_user.first_name }} {{ appeal.reply_user.last_name }}
                        </span>
                        <span>
                          {{ appeal.collaborators }}
                        </span>
                      </td>
                      <td v-if="user && (user.roleCoordinator === true || user.roleAdmin === true)">
                        {{ appeal.whom.transName }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="total-hint">
                  <p>{{ $t('Общее количество обращений') }}: {{ appealsTotal }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="pagesCount"
              :total-visible="10"
            />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Widget from '@/components/app/Widget'
  import AppealSearch from '@/components/appeal/AppealSearch'
  import Appeal from '@/model/appeal'
  import History from "@/components/appeal/History";
  import {mapMutations} from 'vuex'
  import { Trans } from "@/plugins/Translation"

  export default {
    components: {
      Widget,
      AppealSearch,
      History,
    },
    computed: {
      user() {
        return this.$store.state.getUser.currentUser
      }
    },
    data: () => ({
      appeals: [],
      refDeveloper: [],
      refAppealType: [],
      refApplicantType: [],
      refAppealStatus: [],
      search: {},
      page: 1,
      appealsTotal: 0,
      pagesCount: 0,
      breadcrumbs: [],
      sortSettings: {
        fio: null,
        date: null,
        whom: null
      }
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData',
      page() {
        this.fetchData()
      }
    },
    created() {
      this.fetchData()
      this.scrollToTop()
      this.$store.dispatch('fetchCurrentUser')
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        Appeal.getAppealFilterFormData()
          .then((response) => {
            this.refDeveloper = response.data.refDeveloper
            this.refAppealType = response.data.refAppealType
            this.refApplicantType = response.data.refApplicantType
            this.refAppealStatus = response.data.refAppealStatus
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
        this.searchAppeal()
      },
      searchAppeal() {
        this.setLoading(true)
        this.search.page = this.page
        Appeal.getAppealsList(this.search)
          .then((response) => {
            this.appeals = response.data.items
            const paginator = response.data.paginationData
            this.pagesCount = paginator.pageCount
            this.appealsTotal = paginator.totalCount
            this.breadcrumbs = [
              {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
              {text: this.$i18n.t('Обращения'), disabled: true}
            ],
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      //сортировка
      sortData(sortKey) {
        if (
          !this.sortSettings[sortKey] ||
          this.sortSettings[sortKey] === 'desc'
        ) {
          this.sortSettings[sortKey] = 'asc'
        } else {
          this.sortSettings[sortKey] = 'desc'
        }

        this.page = 1
        this.search = {...this.search, ...{page: this.page, orderBy: sortKey, orderDir: this.sortSettings[sortKey]}}
        this.searchAppeal()
      },
      //получаем данные с формы поиска
      getDataSearch(search) {
        this.search = {...this.search, ...search}
        this.page = 1
        this.searchAppeal()
      },
      //очищаем данные с формы поиска
      resetDataSearch() {
        this.search = {}
        this.page = 1
        this.fetchData()
      },
      //прокручиваем на начало страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
